import { oc } from '@orpc/contract';
import { kpiSchema, updateKpiInputSchema } from '../schemas/kpis.schemas.js';
export const updateKpiContract = oc
    .route({
    method: 'PATCH',
    path: '/kpis/{id}',
    tags: ['KPIs'],
    summary: 'Update a KPI (status, Manual ↔ Calculated, formula); 409 with structured formula warnings unless confirmWarnings; 409 listing the board keys when the unit or currency of a board-bound KPI changes (ADMIN, PM)',
})
    .input(updateKpiInputSchema)
    .output(kpiSchema);
//# sourceMappingURL=update-kpi.contract.js.map